const isNotNull = (data) => {
  const key = 'isNotNull'
  const { value } = data
  const isEmpty = value === '' || value === null ? true : false
  const error = isEmpty ? key : false
  return error ? { error, data } : false
}

export default isNotNull
